import _ from 'lodash';

import { handleErrors } from '../../actions/ErrorActions';
import { clearWarnings, enableWarnings, updateAllWarnings } from '../../actions/WarningActions';
import { getAvailableWorkflows, getDefaultChangedItems } from '../../api/app-migration';
import { getValidationWarnings, validateExportData } from '../utils/export.validation.utils';

export const FETCH_CHANGED_ITEMS_LIST_PENDING = 'CHANGED_ITEMS_LIST_FETCH_PENDING';
export const FETCH_CHANGED_ITEMS_LIST_SUCCESS = 'CHANGED_ITEMS_LIST_FETCH_SUCCESS';
export const FETCH_CHANGED_ITEMS_LIST_FAILED = 'CHANGED_ITEMS_LIST_FETCH_FAILED';

export const FETCH_WORKFLOWS_PENDING = 'FETCH_WORKFLOW_PENDING';
export const FETCH_WORKFLOWS_SUCCESS = 'FETCH_WORKFLOWS_SUCCESS';
export const FETCH_WORKFLOWS_FAILED = 'FETCH_WORKFLOWS_FAILED';

export const fetchDefaultChangedItemsPending = () => ({
  type: FETCH_CHANGED_ITEMS_LIST_PENDING,
});

export const fetchDefaultChangedItemsSuccess = (payload) => ({
  type: FETCH_CHANGED_ITEMS_LIST_SUCCESS,
  payload,
});

export const fetchDefaultChangedItemsFailed = (error) => ({
  type: FETCH_CHANGED_ITEMS_LIST_FAILED,
  payload: error,
});

export const fetchWorkflowsPending = () => ({
  type: FETCH_WORKFLOWS_PENDING,
});

export const fetchWorkflowsSuccess = (payload) => ({
  type: FETCH_WORKFLOWS_SUCCESS,
  payload,
});

export const fetchWorkflowsFailed = (error) => ({
  type: FETCH_WORKFLOWS_FAILED,
  payload: error,
});

export const fetchChangedItemsList = () => async (dispatch, getState) => {
  const {
    appMigration: {
      export: { changedItemsList },
    },
  } = getState();

  if (changedItemsList.isLoading || !_.isEmpty(changedItemsList.data)) {
    return;
  }

  dispatch(fetchDefaultChangedItemsPending());

  try {
    const response = await getDefaultChangedItems();

    if (response.hasError) {
      dispatch(handleErrors(response.errors));
      dispatch(fetchDefaultChangedItemsFailed(response.errors));
      return;
    }

    dispatch(fetchDefaultChangedItemsSuccess(response.defaultChangedItems));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`fetchChangedItemsList() failed: ${JSON.stringify(error)}`);
    dispatch(handleErrors(error));
    dispatch(fetchDefaultChangedItemsFailed(error));
  }
};

export const fetchWorkflowsList = () => async (dispatch, getState) => {
  const {
    appMigration: {
      export: { workflowsList },
    },
  } = getState();

  if (workflowsList.isLoading || !_.isEmpty(workflowsList.data)) {
    return;
  }

  dispatch(fetchWorkflowsPending());

  try {
    const response = await getAvailableWorkflows();

    if (response.hasError) {
      dispatch(handleErrors(response.errors));
      dispatch(fetchWorkflowsFailed(response.errors));
      return;
    }

    dispatch(fetchWorkflowsSuccess(response.avaliableWorkflows));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`fetchWorflowsList() failed: ${JSON.stringify(error)}`);

    dispatch(handleErrors(error));
    dispatch(fetchWorkflowsFailed(error));
  }
};

export const validateOnPreview = ({ exportData = {}, selectedPackages = [], isPackagesExport }) => (
  dispatch
) => {
  dispatch(clearWarnings());

  const validationErrors = validateExportData({ exportData, selectedPackages, isPackagesExport });

  if (!validationErrors.length) {
    return;
  }

  const warnings = getValidationWarnings(validationErrors);

  dispatch(updateAllWarnings(warnings));
  dispatch(enableWarnings());

  return validationErrors;
};
